export default {
  cookies: {
    AUTHENTICATED: 'auth.authenticated',
    REFRESH_TOKEN: 'auth.refresh_token',
  },
};
